import React from 'react';
import SafeIcon from '../common/SafeIcon';
import BrandMark from '../components/BrandMark';

const Settings = () => {
  return (
    <div className="max-w-2xl mx-auto space-y-16 pb-20">
      <header className="space-y-3">
        <div className="flex items-center gap-4">
          <BrandMark className="w-12 h-12" />
          <div>
            <h1 className="font-editorial text-5xl tracking-tight leading-none">System Settings</h1>
            <p className="text-[10px] text-graphite-400 font-mono uppercase tracking-[0.3em] mt-2">Configuration Hub • Version 2.4.1</p>
          </div>
        </div>
      </header>

      <div className="space-y-10">
        {/* Section 1 */}
        <section className="space-y-6">
          <h2 className="text-[10px] font-mono uppercase tracking-[0.3em] text-graphite-400 border-b border-pearl-200 pb-4">Style Engine Authorization</h2>
          
          <div className="divide-y divide-pearl-100">
            <div className="py-6 flex items-center justify-between">
              <div className="space-y-1">
                <p className="font-bold text-sm uppercase tracking-tight">Predictive Weather Synthesis</p>
                <p className="text-xs text-graphite-500">Auto-adjust outfit suggestions based on atmospheric sensor data.</p>
              </div>
              <div className="w-12 h-6 bg-runway-500 rounded-full relative cursor-pointer shadow-inner">
                <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full shadow-md transition-all"></div>
              </div>
            </div>

            <div className="py-6 flex items-center justify-between">
              <div className="space-y-1">
                <p className="font-bold text-sm uppercase tracking-tight">Neural Brand Detection</p>
                <p className="text-xs text-graphite-500">Automatic metadata extraction from high-res garment scans.</p>
              </div>
              <div className="w-12 h-6 bg-runway-500 rounded-full relative cursor-pointer shadow-inner">
                <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full shadow-md transition-all"></div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 2 */}
        <section className="space-y-6">
          <h2 className="text-[10px] font-mono uppercase tracking-[0.3em] text-graphite-400 border-b border-pearl-200 pb-4">Archive Management</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
             <button className="flex items-center justify-between p-5 border border-pearl-200 bg-white hover:border-graphite-900 transition-all group">
               <span className="text-[10px] font-bold uppercase tracking-widest">Export Manifesto</span>
               <SafeIcon name="Download" className="w-4 h-4 text-graphite-400 group-hover:text-graphite-900" />
             </button>
             <button className="flex items-center justify-between p-5 border border-pearl-200 bg-white hover:border-runway-500 transition-all group">
               <span className="text-[10px] font-bold uppercase tracking-widest text-runway-500">Purge Metadata</span>
               <SafeIcon name="Trash2" className="w-4 h-4 text-runway-500" />
             </button>
          </div>
        </section>
      </div>

      <footer className="pt-20 text-center border-t border-pearl-100 flex flex-col items-center">
        <BrandMark className="w-10 h-10 mb-6 opacity-30 grayscale" />
        <div className="space-y-2 mb-10">
          <p className="text-xs font-mono font-bold uppercase tracking-[0.4em] text-graphite-900">WardrobeWave OS</p>
          <p className="text-[9px] font-mono text-graphite-400 uppercase tracking-widest">Architecture for the style-conscious.</p>
        </div>
        <p className="text-[9px] font-mono text-graphite-300 uppercase tracking-[0.2em]">
          Made by LingLink AI and DigLab AI
        </p>
      </footer>
    </div>
  );
};

export default Settings;